<template>
    <div>
        <div class="footer">
            <div class="footer-top">
                <div class="left-one-font">权威网址</div>
                <div style="margin:0 10px;"><a href="http://www.moe.gov.cn/" target="_blank" @click="$store.commit('initIsUpdateToken');">教育部</a></div> |
                <div style="margin:0 10px;"><a href="http://gaokao.chsi.com.cn/" target="_blank" @click="$store.commit('initIsUpdateToken');">阳光高考</a></div> |
                <div style="margin:0 10px;"><a href="https://www.chsi.com.cn/" target="_blank" @click="$store.commit('initIsUpdateToken');">学信网</a></div> |
                <div style="margin:0 10px;"><a href="http://www.hneeb.cn/" target="_blank" @click="$store.commit('initIsUpdateToken');">湖南招生考试信息港</a></div> |
                <!-- <div style="margin:0 10px;"><a href="https://eea.gd.gov.cn/" target="_blank" @click="$store.commit('initIsUpdateToken');">广东教育考试院</a></div> | -->
                <div style="margin:0 10px;"><a href="http://www.jyb.cn/" target="_blank" @click="$store.commit('initIsUpdateToken');">中国教育报</a></div> |
                <!-- <div style="margin:0 10px;"><a href="https://www.sceea.cn/" target="_blank">四川教育考试院</a></div> | -->
            </div>
            <div class="footer-top">
                <div class="left-one-font">免费学习入口</div>
                <!-- <div style="margin:0 10px;"><a href="https://ykt.eduyun.cn/" target="_blank">国家中小学网络平台</a></div> | -->
                <div style="margin:0 10px;"><a href="https://basic.smartedu.cn" target="_blank" @click="$store.commit('initIsUpdateToken');">国家智慧教育公共服务平台</a></div> |
            </div>
            <hr class="line"/>
            <table class="footer-md-tab">
                <tr>
                    <td style="width:65%;">
                        <div class="footer-md">
                            <div class="left-one-font">关于我们</div>
                            <div style="margin:0 10px;"><a href="#">品牌简介</a></div>
                            <div style="margin:0 10px;"><a href="#/main/help" @click="$store.commit('initIsUpdateToken');">用户手册</a></div>
                            <div style="margin:0 10px;"><a href="#/main/abouts/yhassess" @click="$store.commit('initIsUpdateToken');">用户评价</a></div>
                            <div style="margin:0 10px;"><a href="#/main/abouts/zjfw" @click="$store.commit('initIsUpdateToken');">专家服务</a></div>
                            <div style="margin:0 10px;"><a href="javascript:void(0)" @click="clickToQuestion">常见问题</a></div>
                        </div>
                        <div class="footer-md">
                            <div class="left-one-font">联系我们</div>
                            <div style="margin-left:10px;color:white;">0731-89722148，19892897119  (招商/客服热线)</div>
                        </div>
                        <div class="footer-md">
                            <div class="left-one-font">技术支持</div>
                            <div style="margin-left:10px;color:white;">湖南豪之天信息技术有限公司</div>
                        </div>
                        <div class="footer-md">
                            <div class="left-one-font">经营许可证编号</div>
                            <div style="margin-left:10px;">
                                <a href="https://beian.miit.gov.cn/" target="_blank"
                                >湘B2-20220719</a>
                            </div>
                            <div style="margin-left:10px;">
                                <a href="https://beian.miit.gov.cn/" target="_blank"
                                >湘ICP备16013382号</a>
                            </div>
                            <div style="margin-left:10px;">
                                <img src="../assets/images/footerimg/beianimg.png" style="width:20px;height:20px;"/>
                                <a href="https://beian.mps.gov.cn/#/query/webSearch" target="_blank"
                                style="margin-left:10px;">湘公网安备43010502001696</a>
                            </div>
                        </div>
                    </td>
                    <td style="width:30%;" align="center">
                        <div style="display:flex;">
                            <div class="right-td-content">
                                <img src="../assets/img/shipinghao_20250429161633.jpg" style="width:100%;margin-bottom:5px;"/>
                                <span>视频号</span>
                            </div>
                            <!-- <div class="right-td-content" style="margin-left: 20px;">
                                <img src="../assets/images/weixin.jpg" style="width:100%;margin-bottom:5px;"/>
                                <span>服务号</span>
                            </div> -->
                            <div class="right-td-content" style="margin-left:20px;">
                                <img src="../assets/images/weixin.jpg" style="width:100%;margin-bottom:5px;"/>
                                <span>订阅号</span>
                            </div>
                        </div>
                    </td>
                </tr>
            </table>
        </div>
    </div>
</template>
<script>
import {mapState} from "vuex";
export default {
methods:{
    clickToQuestion(){
        const type=this.userType;
        if(type===1){
            this.$router.push("/main/abouts/questions");
        }else{
            this.$router.push("/main/other?id=question");
        }
        this.$store.commit('initIsUpdateToken');
    }
},
computed:{
    ...mapState(["userType"])
}
};
</script>
<style scoped lang="less">
.footer{
    // background: #4a4a4a;
    background: #373737;
    .footer-top{
        display: flex;
        align-items: center;
        width: 1100px;
        margin:0 auto;
        padding-top: 20px;
        .left-one-font{
            color:white;
            font-weight:bold;
            margin-right:20px;
        }
        a{
            color: white;
        }
        a:hover{
            color: #0cf;
            text-decoration: none;
            // font-size: 16px;
        }
    }
    .footer-md-tab{
        width: 1100px;
        margin: 0 auto;
        .right-td-content{
            width:100px;
            text-align:center;
            span{
                color:white;
            }
        }
    }
    .footer-md{
        display: flex;
        margin:15px 0;
        .left-one-font{
            color: white;
            font-weight: bold;
            margin-right: 20px;
        }
        a{
            color: white;
        }
        a:hover{
            color: #0cf;
            text-decoration: none;
            // font-size: 16px;
        }
    }
    .line{
        width: 1100px;
        margin-top: 10px;
        margin-left: 159px;
        border: 0; 
        height: 2px; 
        margin: 50px auto;
        background-image: linear-gradient(90deg, transparent, #3a8ee6, transparent);
        border: none;
        height: 0;
        background-image: none;
        margin: 0;
        border: 0.5px solid white;
        margin-top: 10px;
        margin-left: 159px;
    }
}
</style>
